import { useEffect } from 'react';
import NotificationCenter from './notification-center';

/**
 * @param {*} children Notification contents.
 * @param {{ showClose?: boolean, closeDelay?: number }} props Notification options.
 * @returns {null} Renders nothing in-place.
 * @deprecated Use `NotificationCenter.getInstance().notify()` directly instead
 */
export default function Notify({ children, ...props }) {
    useEffect(() => {
        NotificationCenter.getInstance().notify(children, props);
    }, [children, props]); // todo: this will potentially always cause effect to fire, as `props` will always be a new object

    return null;
}
